import { Directive, ElementRef, EventEmitter, Output } from '@angular/core';

@Directive({
    selector: '[blurOrBlurWithin]',
    standalone: true
})
export class BlurOrBlurWithinDirective {


    @Output()
    blurOrBlurWithin: EventEmitter<HTMLElement> = new EventEmitter<HTMLElement>();

    eventFn = () => (e) => {
        if (!this._elmentRef.nativeElement.matches(':focus-within') && !matchMedia('screen and (width <= 1240px)').matches)
            this.blurOrBlurWithin.emit(this._elmentRef.nativeElement);
    }
    constructor(
        private _elmentRef: ElementRef<HTMLElement>,
    ) {

    }

    ngOnDestroy(): void {
        this._elmentRef.nativeElement.removeEventListener('focusout', this.eventFn())
    }

    ngOnInit(): void {
        this._elmentRef.nativeElement.addEventListener('focusout', this.eventFn())
    }


}
